import ax from "./client";
import { buildErrorResponse } from "@/lib/error";
import {
  ApiResponse,
  endpoints,
  IGetPaginatedWalletTransactionsQuery,
  IPaginatedResponse,
  IWalletContext,
  IWalletTransaction,
} from "muminsmart-utils";

export interface ICreateSellerFundAccountInput {
  sellerId: string;
  accountHolderName: string;
  accountNumber: string;
  ifsc: string;
}

export async function getMyWalletContexts(): Promise<
  ApiResponse<IWalletContext | null>
> {
  try {
    const response = await ax<IWalletContext>({
      method: "get",
      url: endpoints.wallet.contextsMe,
    });

    return {
      success: true,
      data: response.data,
      message: "Wallet contexts fetched successfully",
    };
  } catch (error: unknown) {
    return buildErrorResponse(
      error,
      "Error fetching wallet contexts",
      "Error fetching wallet contexts:",
      null,
    );
  }
}

export async function getWalletTransactions(
  walletId: string,
  pagination: IGetPaginatedWalletTransactionsQuery = {},
): Promise<ApiResponse<IPaginatedResponse<IWalletTransaction> | null>> {
  try {
    const response = await ax<IPaginatedResponse<IWalletTransaction>>({
      method: "get",
      url: endpoints.wallet.transactions(walletId),
      params: pagination,
    });

    return {
      success: true,
      data: response.data,
      message: "Wallet transactions fetched successfully",
    };
  } catch (error: unknown) {
    return buildErrorResponse(
      error,
      "Error fetching wallet transactions",
      "Error fetching wallet transactions:",
      null,
    );
  }
}
